import { motion } from "motion/react";
import { observer } from "mobx-react";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import React, { useEffect } from "react";
import { OrgTreeStoreType } from "../org-tree-store";
import { CloseIcon } from "./icons";
import styles from "./OrgTree.module.scss";

/** История изменений структуры: кто, когда, что, было → стало */
export const HistoryPanel = observer(({ store, onClose }: { store: OrgTreeStoreType; onClose(): void }) => {
    useEffect(() => {
        store.loadLog(false);
    }, [store]);

    return (
        <motion.aside
            className={styles.panel}
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 40, opacity: 0 }}
            transition={{ type: "spring", stiffness: 380, damping: 34 }}
            aria-label="История изменений структуры"
        >
            <div className={styles.panelHead}>
                <div>
                    <div className={styles.panelType}>Структура организации</div>
                    <h3>История изменений</h3>
                </div>
                <button type="button" className={styles.close} onClick={onClose} aria-label="Закрыть">
                    <CloseIcon />
                </button>
            </div>
            <div className={styles.panelBody}>
                {!store.log.length && !store.logLoading && (
                    <div className={`${styles.notice} ${styles.info}`}>Изменений пока не было</div>
                )}
                <ul className={styles.logList}>
                    {store.log.map((r) => (
                        <li key={r.id} className={styles.logItem}>
                            <div className={styles.logMeta}>
                                {r.createdAt} · {r.authorName}
                            </div>
                            <div className={styles.logText}>{r.text}</div>
                            {(r.before || r.after) && (
                                <div className={styles.logDiff}>
                                    {r.before && <s>{r.before}</s>}
                                    {r.before && r.after && <span>→</span>}
                                    {r.after && <b>{r.after}</b>}
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
                {store.logHasMore && (
                    <PlanrButton
                        type="secondary"
                        size="small"
                        disabled={store.logLoading}
                        onClick={() => store.loadLog(true)}
                    >
                        Показать ещё
                    </PlanrButton>
                )}
            </div>
        </motion.aside>
    );
});
